import { Provider } from '@angular/core';

import { SignedTimetablesUseCasesImpl } from '@app/domain/use-cases/mot/signed-timetables/signed-timetables.use-cases';
import { SIGNED_TIMETABLES_USE_CASES } from '@app/domain/use-cases/mot/signed-timetables/signed-timetables.use-cases.contract';

export const signedTimetablesUseCasesProvider: Provider = {
  provide: SIGNED_TIMETABLES_USE_CASES,
  useClass: SignedTimetablesUseCasesImpl
};
